import React from "react"
import { Box, Stack } from "@mui/material"
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded"
import SearchTextField from "src/components/table/SearchTextField"
import CustomAutocomplete from "src/components/CustomAutocomplete"
import ViewButton from "src/components/table/ViewButton"
import { Role } from "src/UserService"
import { companyMembersRoleOptions } from "./companyMembersUtils"

const roleOptions = companyMembersRoleOptions

interface MembersFilterBarProps {
  query: string
  onQueryChange: (value: string) => void
  communityFilterSlot: React.ReactNode
  selectedRoleIds: Role[]
  onRolesChange: (roles: Role[]) => void
  onClearFilters: () => void
  rightSlot?: React.ReactNode
}

export function MembersFilterBar({
  query,
  onQueryChange,
  communityFilterSlot,
  selectedRoleIds,
  onRolesChange,
  onClearFilters,
  rightSlot
}: MembersFilterBarProps) {
  const selectedRoleOptions = roleOptions.filter((r) => selectedRoleIds.includes(r.id))

  return (
    <Box
      sx={{
        backgroundColor: "common.white",
        boxShadow: "0px 2px 10px #0719391A",
        borderRadius: "0px 0px 40px 40px",
        px: 8,
        pt: 4,
        pb: 3,
        zIndex: 100
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
        <SearchTextField value={query} onChange={onQueryChange} onClear={() => onQueryChange("")} />
        <Box sx={{ minWidth: 220 }}>{communityFilterSlot}</Box>
        <Box sx={{ minWidth: 220 }}>
          <CustomAutocomplete<{ id: Role; label: string }>
            value={selectedRoleOptions}
            options={roleOptions}
            getOptionLabel={(opt) => opt.label}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            onChange={(_, val) => {
              const arr = (Array.isArray(val) ? val : []) as { id: Role; label: string }[]
              onRolesChange(arr.map((r) => r.id))
            }}
            label="Roles"
            size="small"
            multiple
          />
        </Box>
        <ViewButton onClick={onClearFilters} aria-label="Clear filters">
          <FilterListRoundedIcon />
        </ViewButton>
        {rightSlot}
      </Stack>
    </Box>
  )
}
